import React, { useState } from 'react';
import Pagination from '../../Common/Pagination';
import SectionHeader, { SectionHeaderTypes } from '../../Common/SectionHeader'

export default function InspectionList({ categoryKey = 0, inspectionTypeKey, documentList, selected, onSelectDoc, viewDoc, downloadDoc, downloadAll }) {
    const numberFormatter = new Intl.NumberFormat('en-US', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const dateFormatter = new Intl.DateTimeFormat('en-US', { day: "2-digit", month: "2-digit", year: "numeric" });
    const [selectedPage, setSelectedPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [sortedBy, setSortedBy] = useState('date');
    const [sortOrder, setSortOrder] = useState('desc');

    function handleSelectPage(pageNum) {
        setSelectedPage(pageNum);
    }

    function handleSortByAndOrder(sortByAndOrder) {
        const [sortByParm, sortOrderParam] = sortByAndOrder.split("-");

        setSortOrder(sortOrderParam);
        setSortedBy(sortByParm);
    }

    function handleSortBy(sortBy) {
        let newSortOrder = sortOrder === 'desc' ? 'asc' : 'desc';

        setSortOrder(sortedBy === sortBy ? newSortOrder : 'desc');
        setSortedBy(sortBy);
    }

    function getSortComparer() {
        let isDesc = sortOrder === "desc";
        let compareFn = undefined;
        switch (sortedBy?.toLowerCase()) {
            case 'id':
                compareFn = (a, b) => (isDesc ? b.id - a.id : a.id - b.id);
                break;
            case 'permit':
                compareFn = (a, b) => (isDesc ?
                    (`${b.permitIdentifier}${b.reportId ?? b.ammendmentPosition ?? 0}`).localeCompare(`${a.permitIdentifier}${a.reportId ?? a.ammendmentPosition ?? 0}`) :
                    (`${a.permitIdentifier}${a.reportId ?? a.ammendmentPosition ?? 0}`).localeCompare(`${b.permitIdentifier}${b.reportId ?? b.ammendmentPosition ?? 0}`));
                break;
            case 'approvalstatus':
                compareFn = (a, b) => (isDesc ? ('' + b.approvalStatus).localeCompare(a.approvalStatus) : ('' + a.approvalStatus).localeCompare(b.approvalStatus));
                break;
            case 'type':
                compareFn = (a, b) => {
                    const TypeA = a.inspectionType ?? (categoryKey === 'npdes' ? 'Other' : a.category);
                    const TypeB = b.inspectionType ?? (categoryKey === 'npdes' ? 'Other' : b.category);
                    return isDesc ? ('' + TypeB).localeCompare(TypeA) : ('' + TypeA).localeCompare(TypeB);
                };
                break;
            case 'created':
                compareFn = (a, b) => {
                    const timeA = new Date(a.createdAt).getTime();
                    const timeB = new Date(b.createdAt).getTime();
                    return isDesc ? timeB - timeA : timeA - timeB;
                };
                break;
            case 'date':
            default:
                //sortBy = "inspectionDate";
                compareFn = (a, b) => {
                    const timeA = new Date(a.inspectionDate).getTime();
                    const timeB = new Date(b.inspectionDate).getTime();
                    return isDesc ? timeB - timeA : timeA - timeB;
                };
                break;
        }

        return compareFn;
    }

    let compareFn = getSortComparer(sortedBy, sortOrder);
    let sortedDocList = documentList.toSorted(compareFn);

    let selectedCount = sortedDocList.filter(doc => doc.selected).length;

    let shownDocumentList = sortedDocList.slice((pageSize * selectedPage) - pageSize, (pageSize * selectedPage));

    let documentItems = sortedDocList.length === 0 ? [(<li key="0"><div className="document"><span className="name">No Documents</span></div></li>)] :
        shownDocumentList.map((doc, i) => {
            let viewBtn = (<button className="button" onClick={() => viewDoc(doc)}>View</button>);

            let downloadBtn = (<button className="button" onClick={() => downloadDoc(doc)}>Download</button>);
            if (selectedCount > 0) {
                downloadBtn = (<button className="button disabled">Download</button>);
            }

            let selectDoc = onSelectDoc && (<span className="select" onClick={() => onSelectDoc(categoryKey, doc.id, inspectionTypeKey)}>
                <i className={doc.selected ? "dhicon-check-2" : "dhicon-check-empty"} />
            </span>);

            let permitNum;
            let permitNumSmallScreen;
            if (categoryKey === 'pcir') {
                let noc;
                let permitOrReportId;
                if (doc.reportId) {
                    permitOrReportId = doc.reportId;
                }
                else {
                    noc = doc.ammendmentPosition ? `(Supplemental NOC #${doc.ammendmentPosition})` : undefined;
                    permitOrReportId = doc.permitIdentifier;
                }

                permitNum = (<td className="text-nowrap">{permitOrReportId}{noc && ` ${noc}`}</td>);
                permitNumSmallScreen = (<>
                    <div>
                        <div><span className="label shrink-0">Permit: </span><span>{permitOrReportId}{noc && ` ${noc}`}</span></div>
                    </div>
                    {/*<div><div><span className="label shrink-0"></span><span>{noc}</span></div></div>*/}
                </>);
            }


            return (<tr key={`${doc.id}-${doc.url}-${i}`}>
                <td className="compact">{selectDoc}</td>
                {/*<td className="tabular-nums">{doc.createdAt ? dateFormatter.format(new Date(doc.createdAt)) : '-/-/-'}</td>*/}
                <td className="tabular-nums">{doc.inspectionDate ? dateFormatter.format(new Date(doc.inspectionDate)) : '-/-/-'}</td>
                <td className="">{doc.inspectionType ?? (categoryKey === 'npdes' ? 'Other' : doc.category)}</td>
                <td className="">{doc.id}</td>
                {permitNum}
                {(categoryKey === 'npdes' || categoryKey === 'formlibrary') && (<td>{doc.approvalStatus}</td>)}
                <td className="compact">{downloadBtn}</td>
                <td className="compact">{viewBtn}</td>
                <td className="smallScreen">
                    <div className="flexbox-flex-row-nowrap">
                        {selectDoc}
                        <div className="inspectionItem">
                            <div>
                                {/*<div><span className="label shrink-0">Date:</span><span>{doc.createdAt ? dateFormatter.format(new Date(doc.createdAt)) : '-/-/-'}</span></div>*/}
                                <div><span className="label shrink-0">Date:</span><span>{doc.inspectionDate ? dateFormatter.format(new Date(doc.inspectionDate)) : '-/-/-'}</span></div>
                                <div><span className="label shrink-0">Type:</span><span>{doc.inspectionType ?? (categoryKey === 'npdes' ? 'Other' : doc.category)}</span></div>
                            </div>
                            <div>
                                <div><span className="label shrink-0">ID: </span><span>{doc.id}</span></div>
                            </div>
                            {permitNumSmallScreen}
                            <div>
                                {(categoryKey === 'npdes' || categoryKey === 'formlibrary') && (<div><span className="label shrink-0">Status: </span><span>{doc.approvalStatus}</span></div>)}
                            </div>
                            <div className="buttonContainer">
                                {downloadBtn}
                                {viewBtn}
                            </div>
                        </div>
                    </div>
                </td>
            </tr>);
        });

    if (selectedPage > 1 && pageSize - documentItems.length > 0) {
        let emptyRows = Array.from(
            { length: pageSize - documentItems.length },
            (cv, i) => (<tr className="noBkg" key={`R${i}`}><td><button className="button hide">&nbsp;</button></td></tr>));
        documentItems = documentItems.concat(emptyRows);
    }

    let selectAll = onSelectDoc && (<span className="selectAll" onClick={() => onSelectDoc(categoryKey, undefined, inspectionTypeKey)}>
        <i className={selected ? "dhicon-check-2" : "dhicon-check-empty"} />
        <div>Select</div>
    </span>);

    let sortSelect = (<select className="bg-drhPalette-secondary " onChange={(e) => handleSortByAndOrder(e.target.value)} value={`${sortedBy}-${sortOrder}`}>
        {false && (<>
            <option className="checked:font-semibold checked:text-white" value='created-desc'>Date desc</option>
            <option className="checked:font-semibold checked:text-white" value='created-asc'>Date asc</option>
        </>)}
        <option className="checked:font-semibold checked:text-white" value='date-desc'>Date desc</option>
        <option className="checked:font-semibold checked:text-white" value='date-asc'>Date asc</option>
        {categoryKey === 'formlibrary' && (<>
            <option className="checked:font-semibold checked:text-white" value='type-desc'>Type desc</option>
            <option className="checked:font-semibold checked:text-white" value='type-asc'>Type asc</option>
        </>)}
        <option className="checked:font-semibold checked:text-white" value='id-desc'>ID desc</option>
        <option className="checked:font-semibold checked:text-white" value='id-asc'>ID asc</option>
        {categoryKey === 'pcir' && (<>
            <option className="checked:font-semibold checked:text-white" value='permit-desc'>Permit desc</option>
            <option className="checked:font-semibold checked:text-white" value='permit-asc'>Permit asc</option>
        </>)}
        {(categoryKey === 'npdes' || categoryKey === 'formlibrary') && (<>
            <option className="checked:font-semibold checked:text-white" value='approvalStatus-desc'>Status desc</option>
            <option className="checked:font-semibold checked:text-white" value='approvalStatus-asc'>Status asc</option>
        </>)}
    </select>);

    let selectBarSmallScreen = (<SectionHeader classes="selectAllSmallScreen m-1 pl-0.5 justify-between" sectionHeaderType={SectionHeaderTypes.Secondary}>
        <div className="flex items-center">
            {selectAll}
        </div>
        <div className="text-base">
            <span className="hidden xsm:inline">Sort by</span>
            {sortSelect}
        </div>
    </SectionHeader>);

    let downloadAllBtn = selectedCount > 0 && (<button className="button" onClick={() => downloadAll(categoryKey, inspectionTypeKey)}>Download</button>);


    let sortIconClass = sortOrder === 'desc' ? 'dhicon-down-open' : 'dhicon-up-open';
    
    //let sortableIcon = (<span className="flex"><i className="dhicon-up-open relative -top-1" /><i className="dhicon-down-open relative top-[3px] -left-[22.5px]" /></span>);
    //let sortableColDescClass = "relative -left-[22px]";
    let sortableIcon = (<i className="iconUpDown" />);
    let sortableColDescClass = "";

    let createdAtHeader = (<th onClick={() => handleSortBy('created')} className="cursor-pointer">
        <div className="flex">
            {sortedBy === 'created' ? (<i className={sortIconClass} />) : (sortableIcon)}
            <span className={sortedBy !== 'created' ? sortableColDescClass : ''}>Date</span>
        </div>
    </th>);

    let dateHeader = (<th onClick={() => handleSortBy('date')} className="cursor-pointer">
        <div className="flex">
            {sortedBy === 'date' ? (<i className={sortIconClass} />) : (sortableIcon)}
            <span className={sortedBy !== 'date' ? sortableColDescClass : ''}>Date</span>
        </div>
    </th>);

    let typeHeader = (<th>Type</th>);
    if (categoryKey === 'formlibrary') {
        typeHeader = (<th onClick={() => handleSortBy('type')} className="cursor-pointer">
            <div className="flex">
                {sortedBy === 'type' ? (<i className={sortIconClass} />) : (sortableIcon)}
                <span className={sortedBy !== 'type' ? sortableColDescClass : ''}>Type</span>
            </div>
        </th>);
    }

    let idHeader = (<th onClick={() => handleSortBy('id')} className="cursor-pointer">
        <div className="flex">
            {sortedBy === 'id' ? (<i className={sortIconClass} />) : (sortableIcon)}
            <span className={sortedBy !== 'id' ? sortableColDescClass : ''}>ID</span>
        </div>
    </th>);

    let approvalStatusHeader = (<th onClick={() => handleSortBy('approvalStatus')} className="cursor-pointer">
        <div className="flex">
            {sortedBy === 'approvalStatus' ? (<i className={sortIconClass} />) : (sortableIcon)}
            <span className={sortedBy !== 'approvalStatus' ? sortableColDescClass : ''}>Approval Status</span>
        </div>
    </th>);

    let permitHeader = (<th colSpan="1" onClick={() => handleSortBy('permit')} className="cursor-pointer">
        <div className="flex">
            {sortedBy === 'permit' ? (<i className={sortIconClass} />) : (sortableIcon)}
            <span className={sortedBy !== 'permit' ? sortableColDescClass : ''}>Permit Num</span>
        </div>
    </th>);

    let documents = documentItems.length === 0 ? undefined : (<>
        {selectBarSmallScreen}
        <table className="itemList">
            <thead>
                <tr>
                    <th>{selectAll}</th>
                    {dateHeader}
                    {typeHeader}
                    {idHeader}
                    {categoryKey === 'pcir' && (permitHeader)}
                    {(categoryKey === 'npdes' || categoryKey === 'formlibrary') && (approvalStatusHeader)}
                    <th colSpan="2">Actions</th>
                </tr>
            </thead>
            <tbody>{documentItems}</tbody>
        </table>
        <Pagination itemCount={sortedDocList.length} pageSize={pageSize} selectedPage={selectedPage} hideWhenSinglePage={false} onSelectPage={handleSelectPage}>
            {downloadAllBtn}
        </Pagination>
    </>);

    return documents;
}